import { AvailabilityInfo } from "./AvailabilityInfo";

export interface InHouseTasks {
    id: number;
    name: string;
    description: string;
    coins_amount: number;
    availability: string;
    availability_info: AvailabilityInfo;
    [key: string]: any;
}

export function createInHouseTask(task: any): InHouseTasks {
    const availabilityInfo: AvailabilityInfo = {
        available_at: task.availability_info.available_at,
        available_in: task.availability_info.available_in,
        can_complete: task.availability_info.can_complete,
        is_available: task.availability_info.is_available,
    };

    return {
        id: task.id,
        name: task.name,
        description: task.description,
        coins_amount: task.coins_amount,
        availability: task.availability,
        availability_info: availabilityInfo,
    };
}